import { useApi } from './api';
import { readJsonResponse, type ApiResult } from './apiResponse';
import type {
  AccountCatalogSyncConfigDto,
  AccountCatalogSyncConfigUpdateDto,
  AccountCatalogSyncRunDto,
  SpringPage
} from '../types/accountCatalogSync';

export type { ApiOk, ApiErr, ApiResult } from './apiResponse';

export const useAccountCatalogSyncService = () => {
  const { apiFetch } = useApi();
  const base = '/admin/account-catalog-sync';

  const getCronConfig = async (): Promise<ApiResult<AccountCatalogSyncConfigDto>> => {
    try {
      const res = await apiFetch(`${base}/cron-config`);
      return readJsonResponse<AccountCatalogSyncConfigDto>(res);
    } catch (e) {
      return {
        ok: false,
        status: 0,
        data: null,
        error: e instanceof Error ? e.message : 'Error de conexión'
      };
    }
  };

  const updateCronConfig = async (
    body: AccountCatalogSyncConfigUpdateDto
  ): Promise<ApiResult<AccountCatalogSyncConfigDto>> => {
    try {
      const res = await apiFetch(`${base}/cron-config`, {
        method: 'PUT',
        body: JSON.stringify(body)
      });
      return readJsonResponse<AccountCatalogSyncConfigDto>(res);
    } catch (e) {
      return {
        ok: false,
        status: 0,
        data: null,
        error: e instanceof Error ? e.message : 'Error de conexión'
      };
    }
  };

  const getRuns = async (page: number, size: number): Promise<ApiResult<SpringPage<AccountCatalogSyncRunDto>>> => {
    try {
      const params = new URLSearchParams({
        page: String(page),
        size: String(size),
        sort: 'startedAt,desc'
      });
      const res = await apiFetch(`${base}/runs?${params.toString()}`);
      return readJsonResponse<SpringPage<AccountCatalogSyncRunDto>>(res);
    } catch (e) {
      return {
        ok: false,
        status: 0,
        data: null,
        error: e instanceof Error ? e.message : 'Error de conexión'
      };
    }
  };

  return { getCronConfig, updateCronConfig, getRuns };
};
